import jsPDF from "jspdf";
import logo from "../../assets/logo.png";
import signature from "../../assets/saam-signature.png";
import { calculateOfficeSchemeFee } from "./gstCalculator";

function inr(n) {
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);
}

export function generateOfficeReceiptPDF(application) {
  const fee = calculateOfficeSchemeFee(application.estimateAmount);

  const receiptNo = application.receiptNo || "DRAFT-RECEIPT";
  const receiptDate =
    application.receiptDate || new Date().toLocaleDateString("en-IN");

  const doc = new jsPDF("p", "mm", "a4");
  const navy = [21, 38, 73];
  const gray = [215, 220, 230];

  const x = 20;
  const y = 18;
  const w = 170;
  const h = 210;
  const r = x + w;

  doc.setDrawColor(...navy);
  doc.setLineWidth(0.9);
  doc.rect(x, y, w, h);

  // Header
  doc.addImage(logo, "PNG", 28, 28, 22, 22);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("SHINE AGRI ALLIED AND MARKETING MSCS LTD.", 56, 35);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  doc.text("GSTIN: 24ACNAS4114R1ZV  |  PAN: ACNAS4114R", 56, 44);

  // Title band
  doc.setFillColor(...navy);
  doc.rect(x, 62, w, 12, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("PAYMENT RECEIPT", 105, 70, { align: "center" });

  doc.setTextColor(0, 0, 0);

  // Details
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text(`Receipt No: ${receiptNo}`, 28, 88);
  doc.text(`Date: ${receiptDate}`, r - 28, 88, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Received with thanks from:", 28, 101);

  doc.setFont("helvetica", "bold");
  doc.text(application.societyName || "-", 28, 112, { maxWidth: 148 });

  doc.setFont("helvetica", "normal");
  doc.text(`Reg. No: ${application.registrationNo || "-"}`, 28, 126);
  doc.text(`District: ${application.district || "-"}`, 108, 126);

  // Table
  const tTop = 142;
  const tLeft = 28;
  const tRight = 182;

  doc.setDrawColor(...navy);
  doc.setLineWidth(0.5);
  doc.line(tLeft, tTop, tRight, tTop);

  doc.setFont("helvetica", "bold");
  doc.text("Particulars", tLeft, tTop + 9);
  doc.text("Amount", tRight, tTop + 9, { align: "right" });

  doc.line(tLeft, tTop + 15, tRight, tTop + 15);

  doc.setFont("helvetica", "normal");
  doc.text("Consultancy Fee @ 1.5%", tLeft, tTop + 28);
  doc.text(`Rs. ${inr(fee.consultancyFee)}`, tRight, tTop + 28, {
    align: "right",
  });

  doc.setDrawColor(...gray);
  doc.setLineWidth(0.2);
  doc.line(tLeft, tTop + 34, tRight, tTop + 34);

  doc.text("CGST @ 9%", tLeft, tTop + 43);
  doc.text(`Rs. ${inr(fee.cgst)}`, tRight, tTop + 43, { align: "right" });

  doc.line(tLeft, tTop + 49, tRight, tTop + 49);

  doc.text("SGST @ 9%", tLeft, tTop + 58);
  doc.text(`Rs. ${inr(fee.sgst)}`, tRight, tTop + 58, { align: "right" });

  doc.setDrawColor(...navy);
  doc.setLineWidth(0.5);
  doc.line(tLeft, tTop + 66, tRight, tTop + 66);

  doc.setFont("helvetica", "bold");
  doc.text("Total Received", tLeft, tTop + 79);
  doc.text(`Rs. ${inr(fee.grandTotal)}`, tRight, tTop + 79, {
    align: "right",
  });

  // Payment details box INSIDE main border
  const pTop = 230 - 48; // 182
  doc.setDrawColor(...navy);
  doc.setLineWidth(0.4);
  doc.rect(28, pTop, 154, 36);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(`UTR No: ${application.utrNo || "-"}`, 34, pTop + 13);
  doc.text(`Bank: ${application.bankName || "INDUSIND BANK"}`, 98, pTop + 13);
  doc.text(`Payment Date: ${application.paymentDate || "-"}`, 34, pTop + 25);

  // Signature inside payment box
  doc.addImage(signature, "PNG", 132, pTop + 6, 36, 13);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.8);
  doc.text("Authorized Signatory", 135, pTop + 28);

  doc.save(`Receipt_${application.societyName || "PACS"}.pdf`);
}